<template>
  <Popup
    title="Características del inmueble"
    subtitle="Todos los datos que puedas informar ayudarán a que la valoración sea más precisa."
    color="moles--warning"
    :showCloseIcon="true"
    :showHeaderIcon="false"
    @closePopup="$emit('close')"
  >
    <PropertyFeatures
      :address="address"
      :propertyTypes="types"
      :defaults="defaults"
      :changeMode="true"
      @input="onPropertyFeaturesInput"
      @prevStep="onChangeDirectionRequest"
      @nextStep="$emit('close')"
      @closePopup="$emit('close')"
    />
  </Popup>
</template>

<script>
import Popup from '@/funnels/components/layout/Popup';
import PropertyFeatures from '@/web/official-appraisal/forms/PropertyFeatures';
import axios from 'axios';

export default {
  components: { Popup, PropertyFeatures },

  props: {
    address: {
      type: String,
      required: true,
    },

    types: {
      type: Object,
      required: true,
    },

    defaults: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    onChangeDirectionRequest() {
      window.location = route('official-appraisal.view');
    },
    onPropertyFeaturesInput(form) {
      axios.post(window.location.pathname, form).then(() => window.location.reload());
    },
  },
};
</script>
